import { imageUrl } from 'utils/filestack';

type Args = {
  handle: string;
  mimetype: string | undefined;
  ratio: number;
  width: number;
  height: number;
};

export function headerImageUrl({
  handle,
  mimetype,
  ratio,
  width,
  height,
}: Args) {
  return imageUrl({
    data: { handle, mimetype },
    width: width * ratio,
    height: height * ratio,
    fit: 'crop',
    insecureSVG: true,
  });
}
